import clsx from 'clsx';

export const KittyProgressBar = ({ percentToLevelUp, theBio, height = 25 }) => {
  return (
    <div className='mt-3'>
      <div className='rounded-md overflow-hidden w-full bg-gray-700 relative' style={{ height }}>
        <div className='bg-primary-500 h-full relative' style={{ width: `${percentToLevelUp}%` }}>
          {percentToLevelUp > 45 && (
            <div className={clsx('absolute z-1 inset-0 flex items-center px-3 pb-1 text-black')}>
              <p>
                <span className='text-xs font-semibold'>
                  Level {theBio?.level} - {theBio?.currentExp}/{theBio?.nextLevelExp} XP
                </span>
              </p>
            </div>
          )}
        </div>

        {percentToLevelUp < 45 && (
          <div className={clsx('absolute z-1 inset-0 flex items-center px-3 pb-1 text-white', percentToLevelUp === 0 ? '' : 'justify-end')}>
            <p>
              <span className='text-xs font-semibold'>
                Level {theBio?.level} - {theBio?.currentExp}/{theBio?.nextLevelExp} XP
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
